import script from "./json-input.vue?vue&type=script&setup=true&lang=js"
export * from "./json-input.vue?vue&type=script&setup=true&lang=js"

import "./json-input.vue?vue&type=style&index=0&id=40e4c7da&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40e4c7da"]])

export default __exports__